// Bird field contract shared by the React app AND the web-server Worker
// (web-server/src/birds.js imports this file — wrangler's bundler resolves
// the relative path). One list, one normalizer: a column added here reaches
// both sides at once instead of silently dropping on whichever copy was
// forgotten.

// Fields on the birds table that the app is allowed to write.
export const BIRD_FIELDS = [
  'name', 'ring_number', 'sex', 'color', 'breed', 'year', 'notes',
  'body_photo', 'eye_photo', 'sire_id', 'dam_id'
];

// Normalize a value for SQL binding: empty strings and NaN become NULL so
// numeric/parent columns never receive junk values.
export const toDbValue = (field, value) => {
  if (value === undefined || value === null) return null;
  if (['year', 'sire_id', 'dam_id'].includes(field)) {
    const n = Number(value);
    return Number.isFinite(n) && n > 0 ? n : null;
  }
  if (value === '') return null;
  return value;
};
